module.exports = __webpack_public_path__ + "static/media/index.f6dd29f2.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.26.20@antd/lib/tabs/style/index.less
// module id = 658
// module chunks = 0